import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"lightbulb-circle"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M12 5C14.482 5 16.5 7.019 16.5 9.5C16.5 10.181 16.352 10.834 16.058 11.442C15.545 12.504 14.982 13.708 14.527 15L12 15L9.473 15C9.019 13.708 8.455 12.504 7.943 11.442C7.649 10.834 7.5 10.181 7.5 9.5C7.5 7.019 9.519 5 12 5Z","fillRule":"evenodd","clipRule":"evenodd"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M10.5 18H13.5M12 5C14.482 5 16.5 7.019 16.5 9.5C16.5 10.181 16.352 10.834 16.058 11.442C15.545 12.504 14.982 13.708 14.527 15H9.473C9.019 13.708 8.455 12.504 7.943 11.442C7.649 10.834 7.5 10.181 7.5 9.5C7.5 7.019 9.519 5 12 5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LightbulbCircle = Vue.extend<IconProps>({
  name: 'LightbulbCircleIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'lightbulb-circle',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LightbulbCircle;
